export default __webpack_public_path__ + "static/media/logo.0c5df5ed.png";